import { BodyM, Button, Heading1 } from '@casavo/base-ui'
import useTranslation from 'next-translate/useTranslation'
import getConfig from 'next/config'
import Image from 'next/image'

import { Translated } from '@/components/Translated'
import { useCities } from '@/context/Cities'
import { useModal } from '@/context/ModalContext'
import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'
import { marginBottom, paddingBottom } from '@/shared-styles/styles.css'
import { FilterZone, GeoFilter } from '@/types/filter'

import { saveSearchContent, saveSearchContentTop } from '../../styles.css'
import { ContentWrapper } from '../Common/ContentWrapper'
import { GeoInfo } from '../Common/GeoInfo'

type Props = {
  actualZoneFilterAreas: GeoFilter[]
  isSearchSaved: boolean
}

export const ContentSuccess: React.FC<Props> = ({ actualZoneFilterAreas, isSearchSaved }) => {
  const { t } = useTranslation()
  const { closeModal } = useModal()
  const {
    publicRuntimeConfig: { imageBasePath },
  } = getConfig()

  const cities = useCities()

  return (
    <ContentWrapper
      backToInitialScroll={!isSearchSaved}
      bgColor="white"
      className={sprinkles({ padding: 'l' })}
      origin="SEARCH_RESULTS"
    >
      <div
        className={sprinkles({
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          marginBottom: { desktop: 'xl', mobile: 'l' },
          marginTop: 'l',
        })}
      >
        <div className={sprinkles({ marginBottom: 'm', textAlign: 'center' })}>
          <Image height={124} src={`${imageBasePath}/images/concepts/success.svg`} width={124} />
        </div>
        <Heading1 alignment="center">{t('save-search:Modal_Success_Title')}</Heading1>
      </div>
      <div className={saveSearchContent}>
        <div className={saveSearchContentTop}>
          <>
            <BodyM className={paddingBottom['s-m']}>
              <Translated i18Key="save-search:Modal_Success_Body1" />
            </BodyM>
            <GeoInfo
              activeZones={actualZoneFilterAreas.filter((item): item is FilterZone => item.kind === 'zone')}
              area={cities.router.city?.translatedCityName ?? `${cities.router.area.name} ${t('common:province')}`}
            />
            <BodyM>{t('save-search:Modal_Success_Body2')}</BodyM>
          </>
        </div>

        <Button
          center
          className={marginBottom.m}
          label={t('save-search:Modal_Success_CTA')}
          minWidth={160}
          styleVariant="secondary"
          onClick={() => closeModal({ shouldBackToInitialScroll: isSearchSaved })}
        />
      </div>
    </ContentWrapper>
  )
}
